/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertCurrencyRateLockRequestDto
 */
export interface UpsertCurrencyRateLockRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertCurrencyRateLockRequestDto
     */
    currencyRateId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpsertCurrencyRateLockRequestDto
     */
    entityType?: UpsertCurrencyRateLockRequestDtoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertCurrencyRateLockRequestDto
     */
    entityId?: string;
}


/**
 * @export
 */
export const UpsertCurrencyRateLockRequestDtoEntityTypeEnum = {
    Broker: 'broker',
    Claim: 'claim',
    Submission: 'submission',
    SubmissionSov: 'submission_sov',
    Binder: 'binder',
    Reinsured: 'reinsured',
    Insured: 'insured',
    Contract: 'contract',
    ContractAdjustment: 'contract_adjustment',
    ReviewNote: 'review_note',
    Receipt: 'receipt',
    Layer: 'layer'
} as const;
export type UpsertCurrencyRateLockRequestDtoEntityTypeEnum = typeof UpsertCurrencyRateLockRequestDtoEntityTypeEnum[keyof typeof UpsertCurrencyRateLockRequestDtoEntityTypeEnum];


/**
 * Check if a given object implements the UpsertCurrencyRateLockRequestDto interface.
 */
export function instanceOfUpsertCurrencyRateLockRequestDto(value: object): value is UpsertCurrencyRateLockRequestDto {
    return true;
}

export function UpsertCurrencyRateLockRequestDtoFromJSON(json: any): UpsertCurrencyRateLockRequestDto {
    return UpsertCurrencyRateLockRequestDtoFromJSONTyped(json, false);
}

export function UpsertCurrencyRateLockRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertCurrencyRateLockRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyRateId': json['currencyRateId'] == null ? undefined : json['currencyRateId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function UpsertCurrencyRateLockRequestDtoToJSON(json: any): UpsertCurrencyRateLockRequestDto {
    return UpsertCurrencyRateLockRequestDtoToJSONTyped(json, false);
}

export function UpsertCurrencyRateLockRequestDtoToJSONTyped(value?: UpsertCurrencyRateLockRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyRateId': value['currencyRateId'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
    };
}

